import img14a from '../../../assets/gallery/14a/14a-01-HOME_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img14b from '../../../assets/gallery/14a/14a-02_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img14c from '../../../assets/gallery/14a/14a-03_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img14d from '../../../assets/gallery/14a/14a-04_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';
import img14e from '../../../assets/gallery/14a/14a-05_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "130 x 95 cm",
    pictureSrc: img14a,
    description: "2014",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "130 x 95 cm",
    pictureSrc: img14b,
    description: "2014",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "130 x 95 cm",
    pictureSrc: img14c,
    description: "2014",
    orientation: "v"
  },
  {
    id: 4,
    title: "",
    dimensions: "130 x 95 cm",
    pictureSrc: img14d,
    description: "2014",
    orientation: "v"
  },
  {
    id: 5,
    title: "",
    dimensions: "130 x 95 cm",
    pictureSrc: img14e,
    description: "2014",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/14a/data14a.js